module.exports = __webpack_public_path__ + "img/4.7d1201a6.png";